import { connect } from "react-redux";
import AgentsProfileComponent from "../../Components/Agents/AgentsProfileComponent";
import { setAgentProfiles } from "../../Redux/Actions/AgentProfileActions";
const mapStateToProps = (state) => ({
    AGENT_PROFILES : state.reducer.AGENT_PROFILES,
    ACTIVE_TENANT : state.reducer.ACTIVE_TENANT,
});
const mapDispatchToProps = (dispatch) => ({
    setAgentProfiles: (AGENT_PROFILES) => dispatch(setAgentProfiles(AGENT_PROFILES)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(AgentsProfileComponent);